import { render, staticRenderFns } from "./SuggestedBillableItems.vue?vue&type=template&id=14470442&scoped=true"
import script from "./SuggestedBillableItems.vue?vue&type=script&lang=js"
export * from "./SuggestedBillableItems.vue?vue&type=script&lang=js"
import style0 from "./SuggestedBillableItems.vue?vue&type=style&index=0&id=14470442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14470442",
  null
  
)

export default component.exports